function setLanguage (json, languageId = 'en_US', locales, i18n) {
  return new Promise(resolve => {
    if (!json) throw new Error('参数json不能为空')
    if (!locales) throw new Error('多语言工具方法不能为空')
    if (!i18n) throw new Error('i18n对象不能为空')
    i18n.setLocaleMessage(languageId, json)
    // 设置HUI多语言, 兼容之前非数组的写法
    locales = locales instanceof Array ? locales : [locales]
    locales.forEach((locale) => {
      locale.i18n((key, value) => i18n.t(key, value))
    })
    i18n.locale = languageId
    resolve()
  })
}

export default setLanguage
